<template>
  <div>
    <ul class="work-list">
      <li v-for="item in formData" :key="item.id" @click="handleOpenDetail(item)">
	      <el-image
			   class="work-bg"
			  :src="item.thumb_url"
			  fit="cover"></el-image>
        <div class="work-info">
          <h3>
	          <span class="lg-text-ell lg-list-title">{{item.title}}</span>
          </h3>
	      <h3>
		      <span class="lg-list-item">{{item.category}}</span>
		      <span class="lg-text-ell lg-list-item">{{item.view_count}}人浏览</span>
	      </h3>
        </div>
        <div class="line"></div>
        <div class="work-user-info">
	        <el-row type="flex" align="middle">
		        <el-col :span="10">
			        <div class="user-avatar">
				        <el-avatar :src="item.user_avatar" />
				        <img v-if="item.is_member" :src="item.vip_icon" alt="" class="user-vip">
				        <p style="font-weight: normal;max-width: 60%" class="lg-text-ell lg-list-title lg-f12">{{item.user_name}}</p>
			        </div>
		        </el-col>
		        <el-col :span="14" style="text-align: right">
			        <div class="work-price">
				        <p v-if="item.price && item.price !== 0" style="display: flex;align-items: center;justify-content: flex-end"><img class="price" src="../../assets/img/icon-money.png" alt=""><span style="color: #f88117" class="lg-f12">{{item.price ? item.price:item.material_price}}</span></p>
				        <p v-else style="color: #f88117" class="lg-f12">免费</p>
			        </div>
		        </el-col>
	        </el-row>
        </div>
          <div class="work-mark" v-if="$route.name === 'personal'">
              <p @click.stop="$Bus.$emit('deleteWork',item.id)">
                  <img src="../../assets/img/personal/icon-delete.png" alt="">
                  删除
              </p>
              <p @click.stop="$router.push({query:{name:'created',id:item.id}})">
                  <img src="../../assets/img/personal/icon-white-edit.png" alt="">
                  编辑
              </p>
          </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "index",
  props:['formData'],
  data() {
    return {}
  },
  created() {
    this.$store.state.blank_text='暂无内容，敬请期待'
  },
  methods:{
    // 素材详情
    handleOpenDetail(data){
      const {href} = this.$router.resolve({
        name: 'work_detail',
        query: {
          id:this.$route.name === 'personal' && this.$route.query.name === 'down'?data.material_id:data.id
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style scoped lang='less'>
    .work-list{
        display: flex;
        flex-wrap: wrap;
        border-radius: 4px;
        margin-top: 30px;
        li{
            transition: all .3s;
            background-color: #ffffff;
            padding-bottom: 10px;
            border-radius: 6px;
            margin-right: 28px;
            margin-bottom: 28px;
            width:265px;
            position: relative;
            cursor: pointer;
            .work-bg{
                height: 156px;
                width:100%;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
            }
            .work-info{
                margin-top: 4px;
                h3:first-child{
	                display: flex;
	                justify-content: space-between;
                    span{
	                    max-width: 90%;
                        display: inline-block;
                    }
                }
	            h3:last-child{
		            span:last-child:before{
			            content: "·";
			            color: #8d92a1;
			            font-size: 12px;
			            margin: 0 5px;
		            }
	            }
	            h3{
		            padding:0 10px;
		            p{
			            display: inline-block;
			            padding-right: 10px;
			            img{
				            width: auto;
				            height: 14px;
				            display: inline-block;
				            vertical-align: middle;
			            }
			            span{
				            margin-left:5px;
				            color: #8d92a19c;
				            font-size: 14px;
			            }
		            }
		            p:last-child{
			            img{
				            height: 16px;
				            position: relative;
				            bottom: 2px;
			            }
		            }
		            p:first-child{
			            img{
				            width: 18px;
				            height: 12px;
				            position: relative;
				            bottom: 0px;
			            }
		            }
	            }
                h3:not(:last-child){margin-bottom: 8px;}
            }
            .line{
                height: 1px;
                background-color: #F4F4F4;
                margin: 6px 0 10px;
            }
            .work-user-info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 10px;
	            .work-price{
		            img{
			            display: inline-block;
			            width: 14px;
			            height: 15px;
			            margin-right:7px;
		            }
	            }
                .user-avatar{
                    display: flex;
                    align-items: center;
                    position: relative;
                    .el-avatar{
                        width: 25px;
                        height: 25px;
                        margin-right: 10px;
                    }
                    .user-vip{
                        width: 10px;
                        height: 10px;
                        position: absolute;
                        left: 15px;
                        top: 17px;
                    }
                }
            }
        }
        li:nth-child(5n){
            margin-right:0;
        }
        li:hover{
            transform: translateY(-2px);
            box-shadow: 0 12px 20px 0 rgba(95,101,105,.15);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/work/index.vue